class CrowdfundingInvestment {
    numberOfBricks;
    investedAmount;
    rebatesIncomesAmounts;
    property;
    constructor(data) {
        this.numberOfBricks = data.numberOfBricks;
        this.investedAmount = data.investedAmount;
        this.rebatesIncomesAmounts = data.rebatesIncomesAmounts;
        this.property = data.property;
    }
}
export default CrowdfundingInvestment;
